export default {
  mediaFiles: 'Media Files',
  annotation: 'Annotation',
  loadingImage: 'Loading image...',
  missingImageParams: 'Missing image parameters, cannot enter annotation',
  modelTraining: 'Model Training',
  submitCurrentImageConfirm: 'Submit the current image for model training. Unsaved changes will be saved automatically if needed. Continue?',
  submit: 'Submit',
  cancel: 'Cancel',
  addAnnotationFirst: 'Please add annotations before submitting for model training',
  missingJobInfo: 'Missing job information, cannot submit training',
  modelTrainingSubmitted: 'Model training submitted',
  viewTrainingTask: 'View training task',
  batchModelTraining: 'Batch Model Training',
  batchSubmitConfirm: 'Submit {count} selected image(s) for model training. Unsaved changes will be saved automatically if needed. Continue?',
  selectImagesFirst: 'Please select images to participate in training',
  annotationSaved: 'Annotation saved',
  saveFailed: 'Save failed',
  submitTrainingFailed: 'Submit training failed',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  modelTrainingCount: 'Model Training ({count})',
  folderEmpty: 'No annotatable images in this folder',
  toolbarPan: 'Pan canvas',
  toolbarDrawRect: 'Draw rectangle',
  toolbarDrawPolygon: 'Draw polygon',
  toolbarAiSelect: 'AI point selection',
  toolbarUndo: 'Undo (Ctrl+Z)',
  toolbarRedo: 'Redo (Ctrl+Y)',
  toolbarResetHint: 'Reset to annotations when image was opened',
  toolbarZoomIn: 'Zoom in',
  toolbarFitViewport: 'Fit to window',
  toolbarZoomOut: 'Zoom out',
  resetAnnotations: 'Reset annotations',
  resetAnnotationsConfirm: 'This will restore annotations to when the current image was opened. Unsaved changes will be lost. Continue?',
  reset: 'Reset',
  listTitle: 'Annotations',
  noLabelSelected: 'No label selected',
  delete: 'Delete',
  selectLabel: 'Select label',
  listEmpty: 'No annotations yet',
  shapeRectangle: 'Rectangle',
  shapePolygon: 'Polygon',
  originAi: 'AI',
  originManual: 'Manual',
  saveAnnotations: 'Save annotations',
  selectLabelPlease: 'Please select a label',
  noLabels: 'No labels available',
  unannotated: 'Unannotated',
  searchAndSelectLabel: 'Search and select a label',
  confirmLabel: 'Confirm',
  confirmDefaultLabelHint: 'Last label pre-selected. Press Enter or click Confirm',
  aiRecognizing: 'Recognizing...',
  aiPromptHint: 'Click empty area for positive points (green), inside preview for negative (red). Hover an existing point to remove it.',
  aiPromptCount: '{count} prompt point(s) added',
  aiCandidateScore: 'Confidence {score}%',
  aiCandidateOption: 'Candidate {index}',
  aiSavePrediction: 'Save',
  selectTrainingModel: 'Training Model',
  selectTrainingModelPlaceholder: 'Select a model to train',
  selectTrainingModelPlease: 'Please select a training model',
  selectTrainingVideo: 'Training Video',
  selectTrainingVideoPlaceholder: 'Select a video for training',
  selectTrainingVideoPlease: 'Please select a training video',
  noTrainingVideoAvailable: 'No training videos available in this folder (non-detected .mp4 required)',
  unsavedChangesTitle: 'Unsaved Annotations',
  unsavedChangesContent: 'This image has unsaved annotation changes. Save before continuing?',
  saveAndContinue: 'Save and Continue',
  discardChanges: 'Discard',
}